"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Root = exports.FilterWrapper = exports.FilterContainerWrapper = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div', {
    shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})((param)=>{
    let { hasInitialFacets = true } = param;
    return {
        display: 'flex',
        width: '100%',
        justifyContent: hasInitialFacets ? 'space-between' : 'flex-end',
        alignItems: 'center',
        '&:empty': {
            display: 'none'
        }
    };
});
const FilterWrapper = exports.FilterWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(3)
    };
});
const FilterContainerWrapper = exports.FilterContainerWrapper = (0, _mui.styled)('div')(()=>({
        width: '100%'
    }));
